import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { FormsTurnsService } from 'src/app/services/turns-services/forms-turns-service/forms-turns.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { FormBasic } from 'src/app/models/turns-models/turns-form-basic.model';

@Component({
  selector: 'app-turns-forms-breadcrumb-filter-card',
  templateUrl: './turns-forms-breadcrumb-filter-card.component.html',
  styleUrls: ['./turns-forms-breadcrumb-filter-card.component.scss']
})
export class TurnsFormsBreadcrumbFilterCardComponent implements OnInit {

  @Input() forms;
  centers;
  sessions;
  centersForm = new FormGroup({});
  sessionsForm = new FormGroup({});

  constructor(private formsTurnsService: FormsTurnsService,
              private userStorageService: UserStorageService) { }

  ngOnInit() {
    this.getCenters();
    this.getSessions();
    if (this.userStorageService.getFilterForms()) {
      this.centersForm.patchValue(this.userStorageService.getFilterForms()['centersForm']);
      this.sessionsForm.patchValue(this.userStorageService.getFilterForms()['sessionsForm']);
    }
    this.filter();
  }

  public updateCheckbox(form, reset?) {
    this._toggleCheckboxes(form, reset);
  }

  private _toggleCheckboxes(form, reset) {
    if (reset && form.get('all').value) {
      Object.entries(form.controls).forEach(c => (c[0] !== 'all') ? (c[1] as FormControl).setValue(false) : null);
    } else if (Object.entries(form.controls).find(c => (c[0] !== 'all') && (c[1] as FormControl).value)) {
      form.get('all').setValue(false);
    } else if (!Object.entries(form.controls).find(c => (c[1] as FormControl).value)) {
      form.get('all').setValue(true);
    }
    this.userStorageService.setFilterForms({ centersForm: this.centersForm.getRawValue(), sessionsForm: this.sessionsForm.getRawValue() });
    if (this.userStorageService.getFilterForms()['centersForm']['all'] && this.userStorageService.getFilterForms()['sessionsForm']['all']) {
      this.userStorageService.deleteFilterForms();
    }
    this.filter();
  }

  private getCenters() {
    const centers = new Array<string>();
    this.centersForm.addControl('all', new FormControl(true));
    this.forms.forEach((d: FormBasic) => {
      if (centers.indexOf(d.CenterName) === -1) {
        centers.push(d.CenterName);
        this.centersForm.addControl(d.CenterName, new FormControl(false));
      }
    });
    this.centers = centers;
  }

  private getSessions() {
    const sessions = new Array<string>();
    this.sessionsForm.addControl('all', new FormControl(true));
    this.forms.forEach((d: FormBasic) => {
      if (sessions.indexOf(d.MsessionName) === -1) {
        sessions.push(d.MsessionName);
        this.sessionsForm.addControl(d.MsessionName, new FormControl(false));
      }
    });
    this.sessions = sessions;
  }

  public filter() {
    const forms = {
      centersForm:
      {
        attribute: 'CenterName',
        values: []
      },
      sessionsForm:
      {
        attribute: 'MsessionName',
        values: []
      }
    };
    if (this.centersForm.get('all').value) {
      forms['centersForm'].values = Object.keys(this.centersForm.value).splice(1);
    } else {
      Object.entries(this.centersForm.value).forEach(c => { if (c[1]) { forms['centersForm'].values.push(c[0]); }});
    }
    if (this.sessionsForm.get('all').value) {
      forms['sessionsForm'].values = Object.keys(this.sessionsForm.value).splice(1);
    } else {
      Object.entries(this.sessionsForm.value).forEach(c => { if (c[1]) { forms['sessionsForm'].values.push(c[0]); }});
    }
    this.formsTurnsService.filterForms(forms);
  }
}
